<div id="content" class="allcp-form" ng-controller="OrderListController" ng-init="orders()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="panel-body">
		<div ng-include="'modules/company/dashboard/partials/orders.html'"></div>
	</div>
	<!-- Delete Orders -->
    <div class="modal info-box fade" id="deleteOrdersModal" tabindex="-1" role="dialog" aria-labelledby="deleteOrdersModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content p25">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <p class="pb25">Are you sure you want to delete {{ selectedItems.length == 1 ? 'this' : selectedItems.length }} order{{ selectedItems.length > 1 ? 's' : '' }}?</p>
                        </div>
                    </div>

                    <div class="">
                        <button type="submit" class="btn pull-right btn-danger" ng-click="deleteOrders(false)">
                            Delete
                        </button>
                        <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal">Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</div>
